import classNames from 'classnames';
import { FDPaper, FDStack } from '@facet-wealth/design';
import BottomSpacer from 'Components/ComponentLibrary/Components/Uncategorized/BottomSpacer';
import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import Box from '../../ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = buildUseStyles('StepNavigatorWrapper', (theme) => ({
  root: {
    width: '100%',
    maxWidth: 'inherit',
    padding: theme.spacing(2),
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  navigationContainer: {
    width: '100%',
    maxWidth: theme.dimensions.md,
  },
}));

export const StepNavigatorWrapper = ({ children, className, paperColor }) => {
  const classes = useStyles();
  return (
    <FDPaper appearance={'flat'} rounded={false} width={'100%'} color={paperColor}>
      <Box
        className={classNames(classes.root, className)}
      >
        <div className={classes.navigationContainer}>
          <FDStack spacing={2} alignItems="flex-start" justifyContent="flex-start">
            {children}
          </FDStack>
        </div>
        <BottomSpacer />
      </Box>
    </FDPaper>
  );
};

StepNavigatorWrapper.defaultProps = {
  className: '',
  children: null,
  paperColor: undefined,
};

StepNavigatorWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  paperColor: PropTypes.string,
};
